<template>
    <div>
      <input 
        type="number" 
        v-model="integrationDays" 
        class="form-control" 
        :min="0" 
        :max="360"
        @input="formatNumber"
      >
    </div>
  </template>
  
  <script>
  export default {
    name: 'FieldIntegrationDays',
    props: {
      value: Number
    },
    data() {
      return {
        integrationDays: this.value
      };
    },
    watch: {
      value(newVal) {
        this.integrationDays = newVal;
      },
      integrationDays(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      formatNumber() {
        this.integrationDays = Number(this.integrationDays).toLocaleString();
      }
    }
  }
  </script>
  